<template>
  <!-- Top navigation -->
  <DetailTopNav :heading="this.viewType" :subheading="this.assetType" />

  <!-- Panoramas -->
  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
    v-if="this.assetTypesReady === true"
  >
    <div v-if="viewType == 'balcony-views'" class="m-auto">
      <AnnotationBalcony
        apiUrlEast="https://test.metaluxe.com.au/api/v1/annotations?annotatable_type=asset_images&annotatable_id=144&page=1&per_page=30"
        apiUrlEastMobile="https://test.metaluxe.com.au/api/v1/annotations?annotatable_type=asset_images&annotatable_id=125&page=1&per_page=30"
        apiUrlWest="https://test.metaluxe.com.au/api/v1/annotations?annotatable_type=asset_images&annotatable_id=165&page=1&per_page=30"
        apiUrlWestMobile="https://test.metaluxe.com.au/api/v1/annotations?annotatable_type=asset_images&annotatable_id=166&page=1&per_page=30"
        apiUrlNorth="https://test.metaluxe.com.au/api/v1/annotations?annotatable_type=asset_images&annotatable_id=152&page=1&per_page=30"
        apiUrlNorthMobile="https://test.metaluxe.com.au/api/v1/annotations?annotatable_type=asset_images&annotatable_id=129&page=1&per_page=30"
        apiUrlSouth="https://test.metaluxe.com.au/api/v1/annotations?annotatable_type=asset_images&annotatable_id=153&page=1&per_page=30"
        apiUrlSouthMobile="https://test.metaluxe.com.au/api/v1/annotations?annotatable_type=asset_images&annotatable_id=128&page=1&per_page=30"
      />
    </div>
    <div class="h-100 w-100" v-if="this.assetType == '360-Tours'">
      <iframe
        :src="this.assetTypes[this.order].url"
        :title="this.assetTypes[this.order].title"
        width="100%"
        height="100%"
        allow="fullscreen"
      ></iframe>
    </div>
  </div>

  <OffCanvas />
</template>

<script>
import DetailTopNav from '@/components/DetailTopNav.vue'
import AnnotationBalcony from '@/components/AnnotationBalcony.vue'

import OffCanvas from '@/components/OffCanvas.vue'
import global from '../global'
import BunnyNetService from '@/services/BunnyNetService.js'
import { unslugify } from 'unslugify'

export default {
  name: 'AssetViewDetail',
  props: ['assetType', 'viewType', 'order'],
  components: {
    DetailTopNav,
    AnnotationBalcony,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      currentAsset: null,
      folderStructure: encodeURIComponent(
        this.theme.devFolder +
          '/assets/' +
          this.assetType +
          '/' +
          this.viewType +
          '/'
      ),
      currentIndex: null,
      assetNames: null,
      assetUrls: null,
      componentName: 'AssetView',
      assetTypesReady: false,
    }
  },
  created() {
    if (this.viewType === '3-Bed') {
      this.assetOrder = this.theme.bedAsset.balconyViews
      this.assetNames = this.theme.bedAsset.balconyViewsName
      this.assetUrls = this.theme.bedAsset.balconyViewsUrl
    } else if (this.viewType === 'Amenities') {
      this.assetOrder = this.theme.aminitiesAsset.balconyViews
      this.assetNames = this.theme.aminitiesAsset.balconyViewsName
      this.assetUrls = this.theme.aminitiesAsset.balconyViewsUrl
    } else if (this.assetType === 'retreat') {
      this.assetOrder = this.theme.retreatAsset.balconyViews
      this.assetNames = this.theme.retreatAsset.balconyViewsName
      this.assetUrls = this.theme.retreatAsset.balconyViewsUrl
    }
    BunnyNetService.getRenders(this.folderStructure).then((response) => {
      let j = 0
      // Remap array
      const menuItems = response.data.map((item) => {
        if (this.assetUrls && this.assetUrls.length >= 1) {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
            title: this.assetNames[j],
            url: this.assetUrls[j],
            id: j++,
          }
        } else {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
            title: unslugify(
              item.ObjectName.split('.').slice(0, -1).join('.')
            ).replace('hyphen', '-'),
            url: [],
            id: j++,
          }
        }
      })
      // Custom order array based on section and type
      if (this.assetOrder && this.assetOrder.length >= 1) {
        this.assetTypes = this.reorder(menuItems, this.assetOrder)
      } else {
        this.assetTypes = menuItems
      }
      this.assetTypesReady = true
    })
  },
  methods: {
    // Reorder array based on config setup
    reorder: function (data_array, real_order) {
      var i,
        d = {},
        result = []
      for (i = 0; i < data_array.length; ++i) {
        d[data_array[i].id] = data_array[i]
      }

      for (i = 0; i < real_order.length; ++i) {
        result.push(d[real_order[i]])
      }

      return result
    },
  },
  setup() {
    const { theme } = global

    return {
      theme,
    }
  },
}
</script>
